import { render, staticRenderFns } from "./html.vue?vue&type=template&id=84961b6a&scoped=true"
import script from "./html.vue?vue&type=script&lang=ts"
export * from "./html.vue?vue&type=script&lang=ts"
import style0 from "./html.vue?vue&type=style&index=0&id=84961b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84961b6a",
  null
  
)

export default component.exports